import React from 'react';
import styled from 'styled-components';
import {Image, ImageProps} from '../images';
import { AnimatePresence, motion } from 'framer-motion';

const Styled = styled.div<{$right?: boolean}>`
    position: absolute;
    z-index: 0;
    width: 600px;
    right: ${(p) => (p.$right ? 'initial' : '52px')};
    left: ${(p) => (p.$right ? '52px' : 'initial')};
    opacity: 0.5;
    pointer-events: none;

    ${(p) => p.theme.breakpoints.down('sm')} {
        display: none;
    }
`;

export interface ImageGalleryPeakProps {
    image?: ImageProps;
    right?: boolean;
}

export const ImageGalleryPeak = ({image, right}: ImageGalleryPeakProps): JSX.Element | null => {
    if (!image || !image.src) return null;

    return (
        <Styled $right={right}>
            <AnimatePresence>
                <motion.div
                    className="home-carousel-status-motion"
                    key={image.src}
                    initial={{opacity: 0 }}
                    animate={{opacity: 1 }}
                    transition={{ duration: 1.2 }}
                >
                <Image
                    key={image.src}
                    src={image.src}
                    ratio="rect"
                    optMaxWidth={1000}
                    fit="cover" />
                </motion.div>
            </AnimatePresence>
        </Styled>
    );
};
